import { render, staticRenderFns } from "./MyEvents.vue?vue&type=template&id=79cb496e&scoped=true&"
import script from "./MyEvents.vue?vue&type=script&lang=js&"
export * from "./MyEvents.vue?vue&type=script&lang=js&"
import style0 from "./MyEvents.vue?vue&type=style&index=0&id=79cb496e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cb496e",
  null
  
)

export default component.exports